import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Sunset, Sunrise } from 'lucide-react';
import './CelestialTransition.css';

export const CelestialTransition: React.FC = () => {
  const { celestialTransition } = useTheme();

  // Solo se renderiza si celestialTransition no es null (disparado ÚNICAMENTE por el botón)
  if (!celestialTransition) return null;

  const isSunset = celestialTransition === 'sunset';

  return (
    <div
      className={`celestial-overlay celestial-${celestialTransition}`}
      aria-hidden="true"
      role="presentation"
    >
      {/* 1. Cielo crepuscular / amanecer suave con GPU opacity (sin blur de pantalla completa) */}
      <div className="celestial-sky" />

      {/* 2. Cuerpo solar con halo cálido y ligero */}
      <div className="celestial-sun-wrapper">
        <div className="celestial-sun" />
        <div className="celestial-sun-glow" />
      </div>

      {/* 3. Insignia flotante sutil */}
      <div className="celestial-badge">
        {isSunset ? (
          <>
            <Sunset size={17} color="#FFD97C" />
            <span>Puesta de sol • Modo Noche</span>
          </>
        ) : (
          <>
            <Sunrise size={17} color="#EA8406" />
            <span>Salida de sol • Modo Día</span>
          </>
        )}
      </div>
    </div>
  );
};

export default CelestialTransition;
